<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Resume Uploaded Accounts</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="2" vs-sm="4" vs-xs="12">
          <v-select v-model="per_page" :options="size_per_page" />
        </vs-col>
      </vs-row>

      <vs-table
        class="mb-10"
        @search="handleSearch"
        @sort="handleSort"
        v-model="selected"
        stripe
        :data="uploaded_accounts"
      >
        <template slot="thead">
          <vs-th>S.No</vs-th>
          <vs-th>Uploaded</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">


            <vs-td>
              {{ indextr + 1}}
            </vs-td>
            <vs-td :data="data[indextr].table_name">
              {{ data[indextr].table_name.replace(/_/g, ' ') }}
            </vs-td>
            <vs-td :data="data[indextr].actions">
              <vs-button @click="resumeUploadedAccount(data[indextr].table_name,data[indextr].selected_fields )" color="primary" type="filled"
            >Resume</vs-button
          >
          <vs-button class="ml-5" @click="finishUploadedAccount(data[indextr].table_name)" color="primary" type="filled"
            >Complete</vs-button
          >
              
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <template>
        <vs-pagination
          :total="Math.ceil(total / per_page)"
          v-model="currentx"
        ></vs-pagination>
      </template>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import axios from "@/axios.js";
import vSelect from "vue-select";
export default {
  data: () => ({
                            abilities : null,

    table_name: null,
    log: [],
    selected: [],
    uploaded_accounts: [],
    currentx: 1,
    total: 0,
    size_per_page: [10, 20, 50, 100, 500],
    per_page: 10,
    paginationAttr: {
      page_no: 1,
      per_page: 10
    }
  }),
  components: {
    "v-select": vSelect,
  },
  watch: {
    currentx: function(val) {
      this.paginationSetPageSize();
    },
    per_page: function(val) {
      this.paginationSetPageSize();
    }
  },
  methods: {
    finishUploadedAccount(table_name) {
      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/finish_machine_learning_enhance",
          {'table_name' : table_name}
        )
        .then(response => {
          if (response.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Uploaded Account",
              text: "The uploaded account has been deleted successfully"
            });
          }
          this.getUserUploadedAccounts()
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    paginationSetPageSize() {
      this.paginationAttr = {
        page_no: this.currentx,
        per_page: this.per_page
      };
      this.getUserUploadedAccounts();
    },
    resumeUploadedAccount(table_name , selected_fields) {
      this.$router.push({ name: 'enhanceaccountmachinelearningRemainder', params: { table: btoa(table_name) , selected_fields: btoa(selected_fields) } })
    },
    handleSearch(searching) {
      console.log(`The user searched for: ${searching}`);
    },
    handleSort(key, active) {
      console.log(`the user ordered: ${key} ${active}`);
    },
    getUserUploadedAccounts() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
      axios
        .post(this.$base_url + "/api/enhanced_accounts/get_user_uploaded_accounts", {
          'user_info': userInfo
        })
        .then(response => {
          this.uploaded_accounts = response.data

          //  this.uploaded_accounts.map(function(e){
          //   let redirect_data = {}
          //   redirect_data.table_name = e.table_name
          //   redirect_data.fields = e.selected_fields

          //   e.redirect_data = btoa(redirect_data)
          //   return e
          //  })

          //  console.log("sdfsdfsdf" , atob(this.uploaded_accounts[0].redirect_data))


          //  console.log("sdfsdfsdf" , JSON.parse(atob(this.uploaded_accounts[0].redirect_data)))

          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  created() {
     var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });  
    this.table_name = this.$route.params.tableId;
    this.getUserUploadedAccounts();
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}
</style>

<style lang="stylus">
.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
